import React from 'react';
import { Section, IntroMarkup, Map, Header } from '@components';
const Contacts = ({ contacts, coordinates, header }) => {
  return (
    <Section className={'px-0 md:px-10 lg:px-20'}>
      <Header
        label={header?.label}
        title={header?.title}
        description={header?.description}
      />
      <div className="flex flex-col-reverse  md:flex-row md:items-center">
        <div className=" mt-4 md:mt-0 space-y-4 md:space-y-8 pr-4 w-full  md:w-2/5">
          {contacts?.length > 0 &&
            contacts.map((cont) => {
              const { id, title, contact } = cont;
              return (
                <div key={id}>
                  <span className="label">{title}</span>
                  <IntroMarkup
                    text={contact}
                    className={'text-base address'}
                  />
                </div>
              );
            })}
        </div>
        <div className="w-full h-[400px]">
          <Map coordinates={coordinates} />
        </div>
      </div>
    </Section>
  );
};

export default Contacts;
